/**
 * FeedbackButtons - Thumbs up/down feedback for checkpoint conversations
 *
 * Shows after the conversation ends to collect student feedback on AI quality
 */
import React from "react"
import { View, StyleSheet } from "react-native"
import FeedbackButton from "@common/components/feedback/FeedbackButton"

/**
 * @param {Object} props
 * @param {number|null} props.value - Current feedback value (1, -1, or null)
 * @param {Function} props.onFeedback - Callback when feedback is given
 * @param {boolean} props.disabled - Whether buttons are disabled
 */
const FeedbackButtons = ({
    value = null,
    onFeedback,
    disabled = false
}) => {
    // If feedback already given, show only the selected button
    if (value !== null) {
        return (
            <View style={styles.container}>
                <FeedbackButton
                    onPress={() => {}}
                    disabled
                    isSelected
                    isPositive={value === 1}
                    tooltipText={value === 1 ? "C'était clair" : "Ce n'était pas clair"}
                    minimal
                />
            </View>
        )
    }

    // Show both buttons
    return (
        <View style={styles.container}>
            <FeedbackButton
                onPress={() => onFeedback?.(1)}
                isPositive
                tooltipText="C'était clair"
                minimal
                disabled={disabled}
            />
            <FeedbackButton
                onPress={() => onFeedback?.(-1)}
                isPositive={false}
                tooltipText="Ce n'était pas clair"
                minimal
                disabled={disabled}
            />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: 8
    }
})

export default FeedbackButtons
